import { motion } from "framer-motion";

export const PageBanner = ({ overline, title, subtitle, children }) => {
  return (
    <section className="relative overflow-hidden bg-white pt-32 pb-16 sm:pt-40 sm:pb-20" data-testid="page-banner">
      <div className="pointer-events-none absolute -top-24 right-0 h-96 w-96 rounded-full bg-[#8B5CF6]/20 blur-[120px]" />
      <div className="pointer-events-none absolute top-10 -left-24 h-80 w-80 rounded-full bg-[#A855F7]/15 blur-[120px]" />
      <div className="relative mx-auto max-w-7xl px-6 sm:px-10">
        {overline && (
          <motion.span
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-xs font-semibold uppercase tracking-[0.25em] text-[#6C2BD9]"
          >
            {overline}
          </motion.span>
        )}
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.08 }}
          className="mt-4 max-w-3xl text-5xl font-semibold tracking-tighter text-[#09090B] sm:text-6xl md:text-7xl"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
            className="mt-6 max-w-2xl text-base leading-relaxed text-zinc-600 sm:text-lg"
          >
            {subtitle}
          </motion.p>
        )}
        {children}
      </div>
    </section>
  );
};

export default PageBanner;
